/*
 * @Author: zhangxiaoda zhangxiaoda@nextmar.com
 * @Date: 2025-05-07 15:41:42
 * @LastEditors: zhangxiaoda zhangxiaoda@nextmar.com
 * @LastEditTime: 2025-05-07 15:45:59
 * @FilePath: /zeelool-nextjs/src/api/home.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest } from '@/utils/axios';
import { getStableClientCyyInfo } from '@/utils/currency/client-currency';
import { EPlatform } from '@/utils/enums/platform-enum';
import type { GetComponentProductDataRequest } from './types/api-definition';

export const getHomePageData = (data: { block_type: number; status: number }) =>
  httpRequest('POST:/api/block/block', { data: { ...data, ...getStableClientCyyInfo() } });

// 与服务端首页使用相同的 WAP 初始化接口。
export const getWapHomePageInitData = (data: { block_type: number; status: number }) =>
  httpRequest('POST:/api/block/init_m', { data }, undefined, {
    headers: { 'store-id': EPlatform.WAP },
  });

// 保留原 SSR 的补全范围及 WAP 标识，APP 内嵌首页也使用同一份装修。
export const getWapHomePageSupplementData = () =>
  httpRequest(
    'POST:/api/block/block',
    {
      data: {
        block_type: 204,
        status: 1,
        component_ids: ['brandImage', 'swipeImage2026'],
        ...getStableClientCyyInfo(),
      },
    },
    undefined,
    { headers: { 'store-id': EPlatform.WAP } },
  );

// 领取多个优惠券
export const getBlockCoupons = (data: { coupon_ids: string[] }) =>
  httpRequest('POST:/api/customer/get_block_coupons', { data });

// 获取组件商品数据
export const getComponentProductData = (data: GetComponentProductDataRequest) =>
  httpRequest('POST:/api/block/get_product_data', {
    data: { ...data, ...getStableClientCyyInfo() },
  });
